/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectType } from './subjectType.model';
import { HouseNumberType } from './houseNumberType.model';


export interface BarterSubjectSearchDto { 
    castObce?: string;
    cisloDomovni?: number;
    cisloOrientacni?: string;
    contactId?: number;
    cpCe?: HouseNumberType;
    displayAcreage?: number;
    ico?: number;
    id?: number;
    jmeno?: string;
    lpisId?: number;
    mestskaCast?: string;
    nazev?: string;
    obec?: string;
    okres?: string;
    opsubType?: SubjectType;
    prijmeni?: string;
    psc?: number;
    rodneCislo?: string;
    stat?: string;
    subjectId?: number;
    titulPredJmenem?: string;
    titulZaJmenem?: string;
    ulice?: string;
    uliceKompletni?: string;
}
export namespace BarterSubjectSearchDto {
}


